export default __webpack_public_path__ + "static/media/icons_ero.68553605.svg";